import React from "react";


const renderStationTooltip = (feature) => {
    const {properties} = feature;

    return <div>
        <div>{properties?.code} - {properties?.name}</div>
        {properties?.elevation !== null && <div>{properties?.elevation} mt.</div>}
    </div>
}


export default renderStationTooltip;